// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__H-tkn","wrapper":"Footer_wrapper__T0psY","text":"Footer_text__27sON"};